import { CustomEnum, SpreadEnum } from "./customEnum";

type DocumentTypeKeys =
	| "BankLetter"
	| "PhotoIdentification"
	| "TaxReturn"
	| "BankStatement"
	| "VoidedCheck"
	| "BusinessLicense"
	| "UtilityBill"
	| "PreviousProcessorStatements"
	| "ApplicationUnredacted"
	| "OtherUnderwritingDocuments"
	| "EquipmentOrderingForm"
	| "UnderwritingDocument"
	| "AgentContract"
	| "SignedScheduleA"
	| "ResidualSplitprofileEmail"
	| "Other";

const DocumentTypes = new CustomEnum([
	{
		value: 0,
		name: "BankLetter",
		displayName: "Bank Letter",
	},
	{
		value: 1,
		name: "PhotoIdentification",
		displayName: "Photo Identification",
	},
	{
		value: 2,
		name: "TaxReturn",
		displayName: "Tax Return",
	},
	{
		value: 3,
		name: "BankStatement",
		displayName: "Bank Statement",
	},
	{
		value: 4,
		name: "VoidedCheck",
		displayName: "Voided Check",
	},
	{
		value: 5,
		name: "BusinessLicense",
		displayName: "Business License",
	},
	{
		value: 6,
		name: "UtilityBill",
		displayName: "Utility Bill",
	},
	{
		value: 7,
		name: "PreviousProcessorStatements",
		displayName: "Previous Processor Statements",
	},
	{
		value: 8,
		name: "ApplicationUnredacted",
		displayName: "Application Unredacted",
	},
	{
		value: 9,
		name: "OtherUnderwritingDocuments",
		displayName: "Other Underwriting Documents",
	},
	{
		value: 10,
		name: "EquipmentOrderingForm",
		displayName: "Equipment Ordering Form",
	},
	{
		value: 11,
		name: "UnderwritingDocument",
		displayName: "Underwriting Document",
	},
	{
		value: 12,
		name: "AgentContract",
		displayName: "Agent Contract",
	},
	{
		value: 13,
		name: "SignedScheduleA",
		displayName: "Signed Schedule A",
	},
	{
		value: 14,
		name: "ResidualSplitprofileEmail",
		displayName: "Residual Split Profile Email",
	},
	{
		value: 15,
		name: "Other",
		displayName: "Other",
	},
]) as CustomEnum & SpreadEnum<DocumentTypeKeys>;

export default DocumentTypes;
